import React from 'react';
import { motion } from 'framer-motion';
import { useSessionStore } from '../../store/sessionStore';

const STATUS_CONFIG = {
  connected:    { dot: '#2dd4bf', text: '#2dd4bf',  label: 'Conectado',    bg: 'rgba(45,212,191,0.08)',  border: 'rgba(45,212,191,0.25)' },
  connecting:   { dot: '#fbbf24', text: '#fbbf24',  label: 'Conectando…',  bg: 'rgba(251,191,36,0.08)',  border: 'rgba(251,191,36,0.25)' },
  disconnected: { dot: '#64748b', text: '#64748b',  label: 'Desconectado', bg: 'rgba(100,116,139,0.08)', border: 'rgba(100,116,139,0.2)'  },
  error:        { dot: '#f87171', text: '#f87171',  label: 'Erro',         bg: 'rgba(248,113,113,0.08)', border: 'rgba(248,113,113,0.25)' },
};

export const ConnectionStatus: React.FC = () => {
  const { connectionStatus } = useSessionStore();
  const cfg = STATUS_CONFIG[connectionStatus] ?? STATUS_CONFIG.disconnected;
  const isConnected = connectionStatus === 'connected';

  return (
    <div
      className="flex items-center gap-2 px-3 py-1.5 rounded-full"
      style={{ background: cfg.bg, border: `1px solid ${cfg.border}` }}
    >
      <motion.span
        animate={{ opacity: isConnected ? [1, 0.3, 1] : 1, scale: isConnected ? [1, 1.3, 1] : 1 }}
        transition={{ repeat: isConnected ? Infinity : 0, duration: 2 }}
        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
        style={{ background: cfg.dot }}
      />
      <span className="text-xs font-semibold" style={{ color: cfg.text }}>
        {cfg.label}
      </span>
    </div>
  );
};
